angular.module('dpw.components')

    .directive('dpwDevAppStatusHistory', [function () {
        return {
            restrict: 'A',
            scope: {
                applicationId: '=',
                isLastFromAdmin: '@'
            },
            controller: ['$scope', 'appStatusHistoryService', function ($scope, appStatusHistoryService) {
                if ($scope.isLastFromAdmin === 'true') {
                    appStatusHistoryService.fetchLastFromAdmin($scope, this);
                } else {
                    appStatusHistoryService.fetchAll($scope, this);
                }

                appStatusHistoryService.init($scope, this);
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-dev-app-status-history.html'
        };
    }])

    .directive('dpwAdminAppStatusHistory', [function () {
        return {
            restrict: 'A',
            scope: true,
            controller: ['$scope', 'appStatusHistoryService', function ($scope, appStatusHistoryService) {
                appStatusHistoryService.fetchAll($scope, this);
                appStatusHistoryService.init($scope, this);
            }],
            controllerAs: 'ctrl',
            templateUrl: 'dpw-admin-app-status-history.html'
        };
    }])

    .factory('appStatusHistoryService', ['paging', 'api', 'helpers', function (paging, api, helpers) {
        return {
            fetchAll: function (scope, ctrl) {
                ctrl.pagingHandler = paging.init(scope, render);
                setPerPage(10);
                render();

                function render() {
                    api.call(api.appStates.list(
                        {applicationId: scope.applicationId}, ctrl.pagingHandler.getPaging()
                    ), function (data) {
                        scope.appStates = data.appStates;
                        ctrl.pagingHandler.reset(data);

                        if (scope.paging.page === scope.paging.totalPages) {
                            var lastRecord = _.last(scope.appStates);
                            lastRecord.status === 'Initial' && (lastRecord.isCreateApp = true);
                        }
                    });
                }

                function setPerPage(num) {
                    // TODO: Avoid using internal API of paging service
                    scope.paging.perPage = num;
                }
            },
            fetchLastFromAdmin: function (scope, ctrl) {
                api.call(api.appStates.list(
                    {applicationId: scope.applicationId, role: 'Admin'}, {perPage: 1}
                ), function (data) {
                    scope.appStates = data.appStates;
                });
            },
            init: function (scope, ctrl) {
                var self = this;

                ctrl.getColorClassByAppStatus = function (status) {
                    return helpers.appStateUtil.getColorClassByAppStatus({
                        data: status,
                        isAdminSite: RCDPW.isAdminSite
                    });
                };

                ctrl.getUserName = function (appState) {
                    var username = '';

                    if (_.isString(appState.adminId)) {
                        if (RCDPW.isAdminSite) {
                            username = [_.first(appState.adminId.split('@')), '(Admin)'].join(' ');
                        } else {
                            username = 'Admin';
                        }
                    } else {
                        username = [appState.developer.firstName, appState.developer.lastName].join(' ');
                    }

                    username = username.trim();

                    return _.isEmpty(username) ?
                        RCDPW.Lang.MyAccount.OPERATOR_IS_DELETED_PLACEHOLDER :
                        username;
                };

                scope.$on('appStatusAndReview:appInfoUpdated', function () {
                    scope.isLastFromAdmin !== 'true' && self.fetchAll(scope, ctrl);
                });
            }
        };
    }])

;